import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

/* babel polyfill */
import "core-js/stable";
import "regenerator-runtime/runtime";

/* plugins jquery */
require('jquery-contextmenu');
require('jquery-validation');

/* materialize */
require('materialize-css');

/* pour les select */
require('select2');
require('./select2.translations');

/* tri des tableaux */
require('tablesorter');

/* Définition et binding de l'objet GlobalCourtage */
var GlobalCourtage = function() {};
$.fn.globalcourtage = new GlobalCourtage();
window.globalcourtage = $.fn.globalcourtage;

require('./functions');

$(document).ready(function(){
    globalcourtage.initMaterialize();
    globalcourtage.initDatePicker();
    globalcourtage.toggleMainNavigation();
    globalcourtage.handleFilters();
    globalcourtage.toggleFilters();
    globalcourtage.showHideCheckbox();
    globalcourtage.handlePagination();
    globalcourtage.autocompleteZipcodeCity();
    globalcourtage.contextMenuTrigger();
    globalcourtage.initForm();
    globalcourtage.dupliquerAdresse();
    globalcourtage.fillDataCopierAdresse(); // #4743
    globalcourtage.copierAdresse(); // #4743
    globalcourtage.isAdresseCopiable(); // #4743
    globalcourtage.toggleBoxForm();
    globalcourtage.handleListingColumns();
    globalcourtage.formatNumbers();
    globalcourtage.cliquableRow();
    globalcourtage.cliquableCard();
    globalcourtage.generatePrefixeComptaAgence();
    globalcourtage.exportCheckboxesListing();
    globalcourtage.exportPdfListing();
    globalcourtage.initSideNavs();
    globalcourtage.closeSideNav();
    globalcourtage.handleFilledInputsSelects();
    globalcourtage.beautifyJsonFormat();
    globalcourtage.beautifyXmlFormat();
    globalcourtage.toggleLineDetail();
    globalcourtage.showHideLines();
    globalcourtage.modifDossierSolde();
    globalcourtage.getCountMainQuery();
    globalcourtage.triggerSelectsPointsCadeaux();
    globalcourtage.handleParrainPrincipalApporteurs();
    globalcourtage.autocompleteSelect2Filters();
    globalcourtage.autocompleteSelect2Commerciaux();
    globalcourtage.calculateRangeBetweenDates();
    globalcourtage.autocompleteSelect2FiltersBanques();
    globalcourtage.handleAlertBox();
    globalcourtage.loadingJsClients();
    globalcourtage.initScrollableTable();
    globalcourtage.handleDefautCommercialFMB();
    globalcourtage.handlePolitiqueConfDonnees();
    globalcourtage.addOATachesWrapper();
    globalcourtage.alertBeforeLeavingPage();
    globalcourtage.preventDoubleValidation();
    globalcourtage.ajusteHauteurCards();
});
